import {useTranslation as useReactI18NextTranslation} from 'react-i18next';
import {trim} from 'lodash';

import {getPrefixedEffect, ts, tt} from './TranslationProvider.util';

export const useTranslation = (keyPrefix = '') => {
  // make a call to subscribe to locale change
  useReactI18NextTranslation();

  const prefix = trim(keyPrefix);

  return {
    tt: getPrefixedEffect(tt, prefix),
    ts: getPrefixedEffect(ts, prefix),
  };
};
